module.exports = __webpack_public_path__ + "img/happy.5f20a8e4.png";